
import { DeliveryIdApiService } from '@layers/web/services/delivery-id-api.ts'

/**
 * Identifies users with Customer.io, GA4, Meta and TikTok (see `identifyUser`) when:
 * - Returning after an earlier identify, from the stored hash (GA4, Meta and TikTok only)
 * - Opening the website via links in our emails
 * - Logging in
 */
export default defineNuxtPlugin(() => {
  const { identifyUser, identifyStoredUser } = useTracking()

  /**
   * Runs before the page view plugin so the very first events of the page
   * load already carry the identity, unlike the idle-deferred identifies below
   */
  identifyStoredUser()

  callAfterDocumentIdle(() => {
    const route = useRoute()

    const { did } = route.query

    if (did && typeof did === 'string') {
      DeliveryIdApiService.fetchEmailFromDeliveryId(replaceSpacesWithPlusSigns(did))
        .then((email) => {
          if (!email) {
            return
          }

          identifyUser(email)
        })
        .catch(() => null)
      return
    }

    const userStore = useUserStore()

    const {
      isLoggedIn,
      user,
    } = storeToRefs(userStore)

    watch(
      isLoggedIn,
      () => {
        if (!user.value?.email) {
          return
        }

        identifyUser(
          user.value.email,
          {
            name: user.value.name,
          }
        )
      },
      { immediate: true }
    )
  })
})
